import { dropdownHandler } from './dropdown';
import { anchorWidgetHandler } from './anchor-widget';

const onGenerateContentLoad = () => {
  const generalContent = document.getElementById('general-content');

  if (!generalContent) return;

  const dropdown = generalContent.querySelector('[data-dropdown]');
  const widget = generalContent.querySelector('[data-anchor-widget');
  const tables = generalContent.querySelectorAll('table');

  let currentPosition = null;
  let pageLoaded = false;
  dropdownHandler(dropdown, (value) => {
    if (value === currentPosition) return;
    currentPosition = value;
    if (!pageLoaded) return pageLoaded = true;
    const targetEl = generalContent.querySelector(`#${value}`);

    if (!targetEl) return;
    const offset = targetEl?.getBoundingClientRect()?.top + window.pageYOffset - 120;
    window.scrollTo({
      top: offset,
      behavior: 'smooth'
    });
  });

  anchorWidgetHandler(widget, null, (value) => {
    const targetEl = generalContent.querySelector(value);
    if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth' });
  });

  tables.forEach((table) => {
    const wrapperDiv = document.createElement('div');
    wrapperDiv.classList.add('table-container');
    table.parentNode.insertBefore(wrapperDiv, table);
    wrapperDiv.appendChild(table);
  });

};

export default onGenerateContentLoad;
